import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const initPrimaryHeroSwiper = () => {
  const swiper = new Swiper('.hero__imageContainer', {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.hero__sliderButton-right',
      prevEl: '.hero__sliderButton-left',
      disabledClass: 'pointer-events-none opacity-0',
    },
    pagination: {
      el: '.carousel__pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `
          <div class="bullet-wrapper ${className}">
            <div class="progress-indicator w-2.5 h-2.5 bg-gray-950 rounded-full"></div>
          </div>
        `;
      },
    },
  });

  const updateProgress = () => {
    const bullets = document.querySelectorAll('.bullet-wrapper');
    bullets.forEach((bullet, index) => {
      const progressIndicator = bullet.querySelector('.progress-indicator');
      if (index === swiper.realIndex) {
        bullet.classList.add(
          'relative',
          'h-2.5',
          'w-5',
          'bg-gray-200',
          'rounded-full',
          'flex',
          'items-center',
        );
        progressIndicator?.style.setProperty(
          '--progress-time',
          `${swiper.params.autoplay.delay}ms`,
        );
        progressIndicator?.classList.add(
          'animate-[progress-move_var(--progress-time)_linear]',
        );
      } else {
        bullet.classList.remove(
          'relative',
          'h-2.5',
          'w-5',
          'bg-gray-200',
          'rounded-full',
          'flex',
          'items-center',
        );
        progressIndicator?.classList.remove(
          'animate-[progress-move_var(--progress-time)_linear]',
        );
      }
    });
  };

  const playPauseButton = document.querySelector('.js__playPause');
  const playIcon = document.querySelector('.js__isPaused');
  const pauseIcon = document.querySelector('.js__isPlaying');
  let isManuallyPaused = false;

  if (playPauseButton) {
    playPauseButton.addEventListener('click', () => {
      isManuallyPaused = !isManuallyPaused;
      const activeIndicator = document.querySelector(
        '.bullet-wrapper.swiper-pagination-bullet-active .progress-indicator',
      );
      if (isManuallyPaused) {
        swiper.autoplay.stop();
        activeIndicator?.style.setProperty('animation-play-state', 'paused');
      } else {
        swiper.autoplay.start();
        activeIndicator?.style.setProperty('animation-play-state', 'running');
      }
      playIcon?.classList.toggle('hidden', !isManuallyPaused);
      pauseIcon?.classList.toggle('hidden', isManuallyPaused);
    });
  }

  const stopAutoplay = () => {
    swiper.autoplay.stop();
    isManuallyPaused = true;
    const activeIndicator = document.querySelector(
      '.bullet-wrapper.swiper-pagination-bullet-active .progress-indicator',
    );
    activeIndicator?.style.setProperty('animation-play-state', 'paused');
    playIcon?.classList.remove('hidden');
    pauseIcon?.classList.add('hidden');
  };

  document
    ?.querySelector('.hero__sliderButton-left')
    ?.addEventListener('click', stopAutoplay);
  document
    ?.querySelector('.hero__sliderButton-right')
    ?.addEventListener('click', stopAutoplay);

  swiper.on('slideChange', updateProgress);
  updateProgress();

  const updateEyebrowText = () => {
    const eyebrowElement = document.getElementById('heroEyebrow');
    if (!eyebrowElement) return;

    const allSlides = document.querySelectorAll('.swiper-slide');
    const realIndex = swiper.realIndex;

    // Find the slide that matches the real index and is not a duplicate
    if (allSlides.length > 0) {
      const targetSlide = Array.from(allSlides).find((slide) => {
        return (
          parseInt(slide.dataset.swiperSlideIndex, 10) === realIndex &&
          !slide.classList.contains('swiper-slide-duplicate')
        );
      });
      const eyebrowText = targetSlide?.dataset.eyebrow || '';
      eyebrowElement.textContent = eyebrowText;
    }
  };

  swiper.on('slideChange', updateEyebrowText);
  updateEyebrowText();

  swiper.on('touchStart', stopAutoplay);

  // Video controls
  const videoContainer = document.querySelector('.js__hero__videoContainer');
  if (!videoContainer) return;

  const video = videoContainer.querySelector('video');
  const playPauseBtn = videoContainer.querySelector(
    '.js__hero__videoPlayPause',
  );
  const muteBtn = videoContainer.querySelector('.js__hero__videoMute');

  const videoPausedIcon = playPauseBtn.querySelector('.js__videoPaused');
  const videoPlayingIcon = playPauseBtn.querySelector('.js__videoPlaying');

  const videoMutedIcon = muteBtn.querySelector('.js__videoMuted');
  const videoUnmutedIcon = muteBtn.querySelector('.js__videoUnmuted');

  if (!video) {
    console.error('Video element not found.');
    return;
  }

  // Ensure video is loaded before adding event listeners
  const initVideoControls = () => {
    // Set initial mute state
    if (video.muted) {
      videoMutedIcon?.classList.add('hidden');
      videoUnmutedIcon?.classList.remove('hidden');
    } else {
      videoMutedIcon?.classList.remove('hidden');
      videoUnmutedIcon?.classList.add('hidden');
    }

    // Play/Pause video
    playPauseBtn?.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        videoPausedIcon?.classList.add('hidden');
        videoPlayingIcon?.classList.remove('hidden');
      } else {
        video.pause();
        videoPausedIcon?.classList.remove('hidden');
        videoPlayingIcon?.classList.add('hidden');
      }
    });

    // Mute/Unmute video
    muteBtn?.addEventListener('click', function () {
      video.muted = !video.muted;
      if (video.muted) {
        videoMutedIcon?.classList.add('hidden');
        videoUnmutedIcon?.classList.remove('hidden');
      } else {
        videoMutedIcon?.classList.remove('hidden');
        videoUnmutedIcon?.classList.add('hidden');
      }
    });
  };

  if (video.readyState >= 1) {
    initVideoControls();
  } else {
    video.addEventListener('loadedmetadata', initVideoControls);
  }

  return swiper;
};
